const DEFAULT_TENANT_KEY = 'almamzarcarwash.com';
// const DEV_TENANT_KEY = 'almamzarcarwash.com';
const DEV_TENANT_KEY = 'lamasatcarwash.com';  // was 'almamzarcarwash.com'

const ALMAMZAR_THEME = {
  primary: 'rgb(6, 58, 146)',
  primaryHover: '#0056b3',
  sidebar: '#1e3872',
  sidebarHover: '#14284a',
  accent: '#651017',
  heading: '#05245a',
  action: '#007bff',
  actionHover: '#0056b3',
  themeColor: '#1e3872',
};

const GREEN_THEME = {
  primary: '#047857',
  primaryHover: '#059669',
  sidebar: '#065f46',
  sidebarHover: '#064e3b',
  accent: '#10b981',
  heading: '#064e3b',
  action: '#059669',
  actionHover: '#047857',
  themeColor: '#065f46',
};

/** Invoice / PDF company details — Al Mamzar values kept exact so existing PDFs stay identical. */
const ALMAMZAR_COMPANY = {
  legalName: 'AL MAMZAR CARS WASHING LLC',
  shortName: 'Al-Mamzar Car Wash',
  displayName: 'Al Mamzar Car Wash',
  tagline: 'Vehicle Service Station',
  detailsLabel: 'AlMamzar Car Wash Details:',
  addressLine1: 'Warehouse No. 2, P.O Box: 63798 Jurf Ajman',
  addressLine1Alt: 'Warehouse No. 2, P.O Box: 63798',
  addressLine2Alt: 'Jurf Industrial Zone 2, Ajman, UAE',
  addressFull: 'Warehouse No. 2, P.O Box: 63798 Jurf Industrial Zone 2, Ajman, UAE',
  bankAccountLine: 'RAK Bank Account number : 8193410093901',
  trn: '104630932200003',
  iban: 'AE710400008193410093901',
  tel: '+971 50 367 2862',
  email: 'almamzarcarwash@gmail.com',
  footerBehalf: 'On Behalf of Al Mamzar Car Wash. Ajman.',
  signatoryName: 'Mw Wasi',
  signatoryPhone1: '06-530-4130',
  signatoryPhone2: '050-367-2862',
  teamSignOff: 'Al Mamzar Car Wash Team',
};

/** Lamasat invoice details */
const LAMASAT_COMPANY = {
  legalName: 'LAMASAT CAR POLISHING AND CLEANING',
  shortName: 'Lamasat Car Polishing and Cleaning',
  displayName: 'Lamasat Car Polishing and Cleaning',
  tagline: 'Vehicle Service Station',
  detailsLabel: 'Lamasat Car Wash Details:',
  addressLine1: 'UAE Ajman New Industrial Area',
  addressLine1Alt: 'UAE Ajman New Industrial Area',
  addressLine2Alt: '',
  addressFull: 'UAE Ajman New Industrial Area',
  bankAccountLine: 'Bank Account number : N/A',
  trn: '100429738600003',
  iban: 'N/A',
  tel: '056 976 1284',
  email: 'lamasatcarwash@gamil.com',
  footerBehalf: 'On Behalf of Lamasat Car Polishing and Cleaning.',
  signatoryName: '',
  signatoryPhone1: '',
  signatoryPhone2: '',
  teamSignOff: 'Lamasat Car Polishing and Cleaning Team',
};

const TENANTS = {
  'almamzarcarwash.com': {
    key: 'almamzarcarwash.com',
    displayName: 'Al Mamzar Car Wash',
    theme: ALMAMZAR_THEME,
    company: ALMAMZAR_COMPANY,
  },
  'lamasatcarwash.com': {
    key: 'lamasatcarwash.com',
    displayName: 'Lamasat Car Wash',
    theme: GREEN_THEME,
    company: LAMASAT_COMPANY,
  },
};

function normalizeHost(hostname) {
  if (!hostname) return null;
  return hostname.split(':')[0].toLowerCase().replace(/^www\./, '');
}

function resolveTenantKey(hostname) {
  const host = normalizeHost(hostname);

  if (!host || host === 'localhost' || host === '127.0.0.1') {
    return DEV_TENANT_KEY;
  }

  if (TENANTS[host]) {
    return host;
  }

  return DEFAULT_TENANT_KEY;
}

function formatDomainAsDisplayName(hostname) {
  const host = normalizeHost(hostname);
  if (!host) return 'Car Wash';

  const base = host.replace(/^www\./, '').split('.')[0];
  return base
    .split(/[-_]/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
}

export function getTenantConfig(hostname = window.location.hostname) {
  const tenantKey = resolveTenantKey(hostname);
  const tenant = TENANTS[tenantKey];

  if (tenant) {
    return {
      ...tenant,
      tenantKey,
      isDefaultTenant: tenantKey === DEFAULT_TENANT_KEY,
    };
  }

  return {
    key: tenantKey,
    tenantKey,
    displayName: formatDomainAsDisplayName(hostname),
    theme: ALMAMZAR_THEME,
    company: ALMAMZAR_COMPANY,
    isDefaultTenant: true,
  };
}

/** Invoice/PDF company block for the current domain (Al Mamzar unchanged on its domain). */
export function getInvoiceCompany(hostname = typeof window !== 'undefined' ? window.location.hostname : '') {
  const tenant = getTenantConfig(hostname);
  return tenant.company || ALMAMZAR_COMPANY;
}

export { DEFAULT_TENANT_KEY, DEV_TENANT_KEY, TENANTS, ALMAMZAR_COMPANY, LAMASAT_COMPANY };
